<template>
  <!-- 引导语结束--出报告 -->
  <div class="guide-end-conatin">
    <div
      ref="moveGuideEnd"
      class="guide-end"
    >
      <div class="describe">
        <img
          class="robot"
          src="../assets/image/test-robot-photo.png"
          alt=""
        >
        <div class="box-contain">
          <div class="subject-content">
            <div class="subject-content-bg" />
            {{ content }}
          </div>
          <div
            v-if="!showAnswer"
            class="question-subject-content"
          >
            <ul class="single-select-group">
              <li class="single-select-item">
                <p
                  class="active-text"
                  @click="selectAnswer"
                >
                  {{ simpleText }}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 引导语 -->
      <!-- <div class="guide-language">
        <img
          class="robot"
          src="../assets/image/test-robot-photo.png"
          alt=""
        >
        <ul class="subject-content multiple-choice">
          <li
            class="multiple-item"
            :class="showAnswer ?'active-multiple-item':''"
            :aria-disabled="showAnswer"
            @click="selectAnswer"
          >
            好的，我知道了
          </li>
        </ul>
      </div> -->
      <div
        v-if="showAnswer"
        class="answer-contain"
      >
        <div class="answer">
          <img
            class="user-photo"
            :src="defaultUserPhoto"
            alt=""
          >
          <ul class="answer-item-contain">
            <li class="answer-item">
              {{ simpleText }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getGaugeEvaluationRecord } from "@/assets/utils.js"
export default {
  name: "OldGaudeEnd",
  props: {
    content: {
      type: String,
      default: ''
    },
    showAnswer: {
      type: Boolean,
      default: false
    },
    simpleText: {
      type: String,
      default: "好的，我知道了！"
    }
  },
  data () {
    return {
      answerText: '',
      activeAnswer: '',
      disabled: false,
      disabledCreate: false,
      defaultUserPhoto: require("../assets/image/teacher-nv.png"),
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created () {
    let record = getGaugeEvaluationRecord("", this.gaugeId + "_" + this.versionNum, "")
    if (record && record.recordTime) {
      this.showAnswer = true
    }
  },
  methods: {
    selectAnswer () {
      if (this.showAnswer) {
        return false
      }
      if (this.disabled) {
        return
      }
      // if (this.disabledCreate) {
      //   this.$toast("报告正在生成中，请勿重复提交")
      //   return
      // }
      // this.disabledCreate = true
      this.$emit("loadNextReport", 1)
    },
    // 题目移除动画
    startMoveAnimation () {
      this.$refs.moveGuideEnd.style.left = '-120%'
      this.$refs.moveGuideEnd.style.opacity = "0"
    }
  }
}
</script>

<style lang="scss" scoped>
.guide-end-contain {
  position: relative;
}
.guide-end {
  position: relative;
  left: 0;
  opacity: 1;
  transition: left 0.5s, opacity 0.5s;
  .describe,
  .guide-language {
    display: flex;
    margin-top: 30px;
    .robot {
      width: 80px;
      height: 80px;
      // background: pink;
      border-radius: 50%;
    }
    &:first-child {
      margin-top: 0px;
    }
  }
  .active-multiple-item {
    color: #ffffff;
    background: #00baff;
  }
  .multiple-item:first-child {
    margin-top: 0;
  }
  .box-contain {
    // margin-left: 13px;
    width: 100%;
    font-size: 17px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 26px;
  }
  .single-select-group {
    // max-width: 1355px;
    display: flex;
    flex-wrap: wrap;
    justify-content: safe center;
    // justify-items: center;
    margin-top: 10px;
    .single-select-item {
      padding: 20px 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 48px;
      .select-icon {
        width: 40px;
        height: 40px;
        margin-right: 16px;
      }
      p {
        height: 100%;
        padding: 20px 32px;
        box-sizing: border-box;
        border-radius: 50px;
        box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.02);
        border-radius: 50px;
        border: 1px solid #00baff;
        color: #00baff;
      }
      .active-text {
        background: linear-gradient(300deg, #007fff 0%, #00b1ff 100%);
        border: none;
        color: #ffffff;
        font-size: 32px;
        color: #ffffff;
        line-height: 45px;
      }
    }
    .active-single-item {
      color: #262626;
      background: #ecf7ff;
      border: 1px solid #ecf7ff;
    }
  }
}
</style>
